import audio from '@/scripts/audio';
import eventHub from '@/scripts/eventHub';
import store from '@/store';
import {
  AnimatedSprite,
  Loader,
  Point,
  Sprite,
  Text,
} from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import vars from '../vars';

class Score {
  constructor(parent, player) {
    this.parent = parent;
    this.player = player;
    this.internalScore = 0;
    this.scoreGap = 0.01;
    this.prevPoints = 0;
    this.played = false;

    this.sprite = new Sprite();
    this.confetti = new AnimatedSprite(Object.values(Loader.shared.resources['sprites/SCORE_CONFETTI'].textures));
    this.confetti.loop = false;
    this.confetti.animationSpeed = 0.4;
    this.confetti.anchor = new Point(0.5, 1);
    this.confetti.position.y += 30;
    this.line = new Sprite(Loader.shared.resources['textures/SCORE_LINE'].texture);
    this.shadow = new Sprite(Loader.shared.resources['textures/SCORE_LINE_SHADOW'].texture);
    this.text = new Text(`${store.state.userData.score} m`, {
      fontFamily: 'Gucci sans',
      fontSize: 22,
      fill: 0xFFDF00,
    });
    this.text.anchor = new Point(0.5, 1);
    this.text.position.x = vars.layout.FRAME_WIDTH / 2;
    this.text.position.y = -20;
    this.sprite.position.y = vars.layout.FRAME_HEIGHT;
    this.shadow.position.x = 4;
    this.sprite.addChild(this.text);
    this.sprite.addChild(this.line);
    this.sprite.addChild(this.confetti);
    this.sprite.addChild(this.shadow);
    this.parent.addChild(this.sprite);
    this.sprite.renderable = false;

    this.frameHandler = () => { this.frame(); };
  }

  start() {
    this.internalScore = 0;
    this.prevPoints = 0;
    ticker.add(this.frameHandler);
  }

  stop() {
    ticker.remove(this.frameHandler);
  }

  frame() {
    if (this.sprite.renderable) {
      this.sprite.position.y -= state.speed * ticker.speed;
      const { top } = this.sprite.getBounds();
      this.shadow.position.y = (top - (vars.layout.FRAME_HEIGHT / 2)) * 0.03;

      const { top: playerTop } = this.player.sprite.getBounds();
      const { bottom: spriteBottom, height } = this.sprite.getBounds();
      if ((spriteBottom - (height / 2)) < playerTop && !this.played) {
        this.confetti.position.x = this.player.sprite.position.x;
        this.confetti.gotoAndStop(0);
        this.confetti.play();
        eventHub.$emit('shake');
        audio.play('record');
        this.played = true;
      }

      if (spriteBottom < 0) {
        this.sprite.renderable = false;
        this.played = false;
      }
    }

    this.internalScore += this.scoreGap * state.speed;
    if (this.prevPoints !== this.points) {
      this.prevPoints = this.points;
      state.score = this.points;

      if (state.score === store.state.userData.score && store.state.userData.score !== 0) {
        this.sprite.position.y = vars.layout.FRAME_HEIGHT;
        this.sprite.renderable = true;
      }
    }
  }

  get points() {
    return parseInt(this.internalScore, 10);
  }
}

export default Score;
